import { render } from "./DeleteBinIcon.vue?vue&type=template&id=64c59624"
import script from "./DeleteBinIcon.vue?vue&type=script&lang=js"
export * from "./DeleteBinIcon.vue?vue&type=script&lang=js"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__